import 'es6-promise/auto'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import LaunchDarklyPlugin from './plugins/launchDarkly'
import 'vue-awesome/icons'
import SmoothScroll from 'vue-smoothscroll'
import Icon from 'vue-awesome/components/Icon'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import App from './App'
import store from './store'
import router from './router'
import i18n from './locales'
import { EventBus } from './utils/event-bus'

import './styles/tailwind.css'

Vue.config.productionTip = false

if (process.env.VUE_APP_ENV === 'production') {
  Sentry.init({
    dsn: 'https://dffc5a2cc1b04a66a9046b5dee53a640@sentry.io/1526540',
    integrations: [
      new VueIntegration({ Vue, attachProps: true })
    ],
    environment: process.env.VUE_APP_BRANCH === 'master' ? 'production' : 'review',
    release: process.env.VUE_APP_COMMIT
  })
}

/* eslint-disable */
// Google Tag Manager
if (process.env.VUE_APP_ENV === 'production') {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-KV8LLGS');
}
// End Google Tag Manager
/* eslint-enable */

// eslint-disable-next-line vue/multi-word-component-names
Vue.component('icon', Icon)
Vue.use(SmoothScroll)

Vue.use(LaunchDarklyPlugin, {
  clientId: process.env.VUE_APP_LAUNCH_DARKLY_CLIENT_ID,
  context: {
    key: 'anonymous-user',
    kind: 'user',
    anonymous: true
  }
})

require('es6-object-assign').polyfill()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: {
    App,
    Icon
  }
})
